import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function InfoToolTip({ title = 'Title here', fontSize = '20px' }) {
  return (
    <Tooltip
      title={title}
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'grey.800',
            fontSize: '13px',
            maxWidth: 300,
            '& .MuiTooltip-arrow': {
              color: 'grey.800',
            },
          },
        },
      }}
    >
      <InfoIcon
        sx={{
          fontSize: { fontSize },
          color: 'text.secondary',
          ml: 1.5,
          verticalAlign: 'middle',
          position: 'relative',
          top: '-2px',
          cursor: 'pointer',
          transition: 'all 0.2s',
          '&:hover': {
            color: 'primary.main',
            transform: 'scale(1.1)',
          },
        }}
      />
    </Tooltip>
  );
}
InfoToolTip.propTypes = {
  title: PropTypes.string,
  fontSize: PropTypes.string,
};

export default InfoToolTip;
